import styled from '@emotion/styled';

export const CalendarWrapper = styled('div', { label: 'CalendarWrapper' })`
    width: 330px;
    margin-top: -16px;
    .react-datepicker {
        > div {
            display: flex;
            flex-flow: row nowrap;
        }
        .react-datepicker__time-container,
        .react-datepicker__month-container {
            float: none;
        }
        .react-datepicker__time-container {
            flex: 0 0 84px;
        }
    }
`;

export const DatePickerWrapper = styled('div', { label: 'DatePickerWrapper' })`
    .react-datepicker__aria-live {
        display: none;
    }
    .react-datepicker__tab-loop {
        > div {
            top: -16px;
        }
    }
    .react-datepicker-popper {
        > svg {
            display: none;
        }
    }
    .react-datepicker-wrapper {
        display: flex;
    }
`;
